import { TransferAssetApproverService } from './transfer-asset-approver.service';
import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, Resolve, RouterStateSnapshot } from '@angular/router';
import { TRANSFER_ASSET_APPROVER_TYPE, TransferAssetApprover } from 'assets-model';
import { Observable } from 'rxjs';



@Injectable({ providedIn: 'root' })
export abstract class TransferAssetApproverResolverBase implements Resolve<TransferAssetApprover> {

  constructor(protected service: TransferAssetApproverService) {
  }

  resolve(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<TransferAssetApprover> {
    const key: string = TRANSFER_ASSET_APPROVER_TYPE.entityDecorator.toKeyObjectFromRouteParams(route.params);
    return this.service.get(key);
  }
}



